import { render, staticRenderFns } from "./RealEstateAgencyDetails.vue?vue&type=template&id=ef2ee62c&scoped=true&"
import script from "./RealEstateAgencyDetails.vue?vue&type=script&lang=js&"
export * from "./RealEstateAgencyDetails.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateAgencyDetails.vue?vue&type=style&index=0&id=ef2ee62c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2ee62c",
  null
  
)

export default component.exports